(function () {
  var availabilityParameter = 'filter.v.availability';

  function isAvailabilityInput(input) {
    return input.name === availabilityParameter;
  }

  function hasNonAvailabilityFilter(searchParams) {
    return Array.from(searchParams.keys()).some(function (key) {
      return key.indexOf('filter.') === 0 && key !== availabilityParameter;
    });
  }

  function addAvailabilityToUrl(value) {
    if (!value) return value;

    // Cornerstone stores removal targets as query strings without a leading ?.
    var searchParams = new URLSearchParams(value);

    if (hasNonAvailabilityFilter(searchParams) && !searchParams.has(availabilityParameter)) {
      searchParams.set(availabilityParameter, '1');
    }

    return searchParams.toString();
  }

  function enableAvailabilityInForm(form) {
    if (!form) return;

    var availabilityInput = Array.from(form.querySelectorAll('[data-filter-item-input]')).find(
      isAvailabilityInput
    );

    if (availabilityInput) availabilityInput.checked = true;
  }

  function syncDrawerInert() {
    var drawer = document.querySelector('[data-filter-drawer]');
    if (!drawer) return;

    drawer.toggleAttribute('inert', drawer.getAttribute('aria-hidden') === 'true');
  }

  try {
    var currentUrl = new URL(window.location.href);

    // A bookmarked or externally linked filtered URL still needs correcting.
    // Ordinary collection/search visits are deliberately not redirected.
    if (
      hasNonAvailabilityFilter(currentUrl.searchParams) &&
      !currentUrl.searchParams.has(availabilityParameter)
    ) {
      currentUrl.searchParams.set(availabilityParameter, '1');
      window.location.replace(currentUrl.toString());
      return;
    }
  } catch (error) {
    console.warn('Availability filter URL check skipped:', error);
  }

  // Capture the change before Cornerstone serialises the form. This adds
  // availability to the same AJAX request rather than starting a second load.
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      var form = input.closest && input.closest('[data-filter-form]');

      if (!form || !input.name || input.name.indexOf('filter.') !== 0) return;

      if (isAvailabilityInput(input)) {
        var hasAnotherActiveFilter = Array.from(form.elements).some(function (element) {
          if (!element.name || element.name.indexOf('filter.') !== 0 || isAvailabilityInput(element)) {
            return false;
          }

          if (element.type === 'checkbox' || element.type === 'radio') return element.checked;
          return element.value !== '';
        });

        if (hasAnotherActiveFilter && !input.checked) input.checked = true;
        return;
      }

      enableAvailabilityInForm(form);
    },
    true
  );

  // Active-filter removal links bypass form serialisation, so amend only links
  // that would otherwise leave another filter active without availability.
  document.addEventListener(
    'click',
    function (event) {
      var removalLink = event.target.closest('[data-remove-filter], [data-remove-range]');

      if (removalLink) {
        var removalUrl = removalLink.getAttribute('data-url-to-remove');
        if (removalUrl) removalLink.setAttribute('data-url-to-remove', addAvailabilityToUrl(removalUrl));
      }

      var drawer = document.querySelector('[data-filter-drawer]');
      if (!drawer) return;

      var drawerToggle = event.target.closest('[data-drawer-toggle]');
      if (drawerToggle && drawer.getAttribute('aria-hidden') === 'true') {
        drawer.removeAttribute('inert');
        return;
      }

      if (
        event.target.closest('[data-close-drawer], [data-filter-drawer-apply], [data-filter-drawer-wash]') ||
        drawerToggle
      ) {
        requestAnimationFrame(syncDrawerInert);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') requestAnimationFrame(syncDrawerInert);
  });

  syncDrawerInert();
})();
